import Flickity from 'flickity';
import '../util/checkTouch';
import '../util/clickTile';
import '../util/lazyLoad';
import '../util/togglePanel';
import '../util/toggleSearch';
import '../util/toggleScroll';
import '../util/megaMenu';
import '../util/multiSelect';
import '../util/popUp';
import '../util/share';
import '../util/sideNav';
import '../util/tabs';

// const preAjax = window.a9sf823fa;

export default {
  init() {

    // Footer Blog Mobile Carousel
    var footerBlog = document.querySelector('.footer__blog-posts');
    if(footerBlog) {
      new Flickity(footerBlog,{
        prevNextButtons: false,
        // cellAlign: 'left',
        watchCSS: true
      });
    }

    // Related/Suggested Products Mobile Carousel
    var relatedProducts = document.querySelector('.product__related-listing');
    if (relatedProducts) {
      new Flickity(relatedProducts,{
        prevNextButtons: false,
        watchCSS: true
      });
    }
  },
  finalize() {
    // Sticky Nav
    let prevScrollPos = 0;
    let curScrollPos = 0;
    const topBar = document.querySelector('.header__top-bar');
    const topBarHeight = topBar.clientHeight;
    const mainNav = document.querySelector('.header__navigation');

    function stickyNav() {
      curScrollPos = window.scrollY;
      const mainNavHeight = mainNav.clientHeight;
      const mainNavOffset = topBarHeight + mainNavHeight;

      if(curScrollPos > prevScrollPos) {
        if(curScrollPos > mainNavOffset) {
          mainNav.classList.add('is-hidden');
        }
      } else if (curScrollPos < prevScrollPos) {
        if(curScrollPos > topBarHeight) {
          mainNav.classList.add('is-sticky');
          mainNav.classList.remove('is-hidden');
        } else {
          mainNav.classList.remove('is-sticky');
        }
      }
      prevScrollPos = curScrollPos;
    }

    // openPopUp('popup-newsletter'); // TEMP: Test only

    window.addEventListener('scroll', stickyNav);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js